module.exports = __webpack_public_path__ + "static/img/Nat-Fyfe.9e9b24c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nat-Fyfe.jpg
// module id = USRm
// module chunks = 0